export function getWidget(metaData, pageId, compId) {
    var page = metaData.pages && metaData.pages[pageId];
    if (!page) {
        throw new Error("Page " + pageId + " not found in siteQuery");
    }
    var widget = page.widgetComponents && page.widgetComponents[compId];
    if (!widget) {
        throw new Error("Widget " + pageId + " not found in siteQuery");
    }
    return widget;
}
//# sourceMappingURL=getWidget.js.map